import {Row, Col, Icon, Modal, Button, Pagination} from 'antd';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty'
import WeaNewScroll from '../../wea-new-scroll';
import WeaSearchAdvance from '../../wea-search-advance';
import debounce from 'lodash/debounce'
import data from './data';
import './index.less'
import WeaLocaleProvider from '../../wea-locale-provider';
const getLabel = WeaLocaleProvider.getLabel;

const initialState = {
    pageSize: 10,
    currentPage: 1,
    tableData: [],
    total: data.length,
    displayData: cloneDeep(data),
    inputValue: '',
}

class main extends React.Component {
    constructor(props) {
        super(props);
        this.state = cloneDeep(initialState);
        this.state.value = props.value || '';
        this.state.visible = false;
    }
    componentDidMount() {
        this.props.initFunc && this.props.initFunc(this);
    }
    componentWillReceiveProps(nextProps){
        if ('value' in nextProps && this.props.value !== nextProps.value) {
            this.setState({value: nextProps.value});
        }
    }
    getData(currentPage = 1) {
        const {pageSize, total, displayData} = this.state;
        let start = pageSize * (currentPage - 1);
        let end = pageSize * currentPage > total? total: pageSize * currentPage
        const tableData = displayData.slice(start, end);
        this.setState({tableData});
    }
    onSearchChange(v){
        const {pageSize} = this.state;
        const all = cloneDeep(data);
        const displayData = all.filter((item)=> item.indexOf(v) > -1);
        const total = displayData.length;
        const currentPage = 1;
        let start = pageSize * (currentPage - 1);
        let end = pageSize * currentPage > total? total: pageSize * currentPage
        const tableData = displayData.slice(start, end);
        this.setState({displayData, total, currentPage, tableData, inputValue: v});
    }
    closeModal() {
        this.setState(initialState);
        this.setState({visible: false});
    }
    openModal() {
        this.setState({visible: true});
    }
    handleClear() {
        this.closeModal();
        this.setState({value: ''});
        this.props.onChange && this.props.onChange('');
    }
    handleCancel() {
        this.closeModal();
    }
    open() {
        this.setState(initialState);
        this.getData();
        this.openModal();
    }
    set(value) {
        this.setState({value})
    }
    get() {
        const {value} = this.state;
        return {
            value,
        };
    }
    onRowClick(name){
        this.setState({value: name});
        this.props.onChange && this.props.onChange(name);
        this.closeModal();
    }
    getSearchType() {
        return ['base'];
    }
    render() {
        let _this = this;
        const {customized, buttons, contentHeight,icon,iconBgcolor, title, modalStyle, text=getLabel(83738 ,'更换')}=this.props;
        const {pageSize, total, currentPage, value, tableData, inputValue, visible} = this.state;
        let titleEle = (
            <Row>
                <Col span="22" style={{paddingLeft:20,lineHeight:'48px'}}>
                    <div className="wea-hr-muti-input-title">
                        {iconBgcolor ? <div className="wea-workflow-radio-icon-circle"
                            style={{background:iconBgcolor ? iconBgcolor : ""}}><i className={icon}/></div>
                        : <span style={{verticalAlign:'middle',marginRight:10}}><i className={icon}/></span>}
                        <span style={{verticalAlign:'middle'}}>{title}</span>
                    </div>
                </Col>
            </Row>
        );
        let inputArr = <div className="wea-browser-icons" style={{display: 'inline-block'}}>
                {value &&
                    <span style={{display: 'inline-block', lineHeight: '30px'}}>
                        <span className={value} style={{color: '#16a1fd', fontSize: 17, marginRight: 10}}>
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </span>
                    </span>
                }
                <Button type="ghost" onClick={this.open.bind(this)}>{text}</Button>
            </div>
        const footer = buttons || [
            <Button type="ghost" onClick={this.handleClear.bind(this)}>{getLabel(385566 ,'清 除')}</Button>,
            <Button type="ghost" onClick={this.handleCancel.bind(this)}>{getLabel(385567 ,'取 消')}</Button>];

        const cHeight = contentHeight - 46;
        let dom = inputArr;
        if (customized) {
            dom = (
                <div className="cursor-pointer" onClick={this.openModal}>
                    {this.props.children}
                </div>
            )
        }
        return (
          <div>
           {dom}
           <Modal wrapClassName="wea-browser-single wea-browser-modal wea-browser-icons"
              title={titleEle}
              zIndex={this.props.zIndex}
              width={modalStyle.width}
              maskClosable={false}
              visible={visible}
              onCancel={this.handleCancel.bind(this)}
              footer={footer}>
                <div className="prel">
                    <WeaSearchAdvance
                        searchType={this.getSearchType()}
                        searchsBaseValue={inputValue}
                        onSearchChange={debounce(this.onSearchChange, 200).bind(this)}
                        onSearch={this.onSearchChange.bind(this)}
                    />
                    <div>
                        <Row className="icons-header">
                            <Col span={6} style={{paddingLeft: 60}}>{getLabel(82757 ,'图标')}</Col>
                            <Col span={18}>{getLabel(33439 ,'名称')}</Col>
                        </Row>
                        {
                            !isEmpty(tableData) && <div style={{height: 365}}>
                                {
                                    tableData && tableData.map((item) => {
                                        return <Row className="cursor-pointer icons-th" onClick={this.onRowClick.bind(this, item)}>
                                            <Col span={6} style={{paddingLeft: 60, fontSize: 16}}>
                                                <span className={item} style={{color: '#16a1fd'}}>
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </span>
                                            </Col>
                                            <Col span={18}>{item}</Col>
                                        </Row>
                                    })
                                }
                            </div>
                        }
                        {
                            isEmpty(tableData) && <div className="align-center" style={{paddingTop: 20, color: '#666', height: 400}}>{getLabel(385596 ,'没有找到图标')}</div>
                        }
                        {
                            total > 0 &&
                            <Pagination weaSimple current={currentPage} pageSize={pageSize} total={total}
                                onChange={(page)=> {this.getData(page); this.setState({currentPage: page})}}/>
                        }
                    </div>
                </div>
            </Modal>
          </div>
        );
    }
}

export default main;


// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-icons/index.js